import CardContainer from "@/components/cards/CardContainer";
import ComingSoonBadge from "@/components/badge/ComingSoonBadge";
import Container, { Column, Row } from "@/components/container/Container";

const CARDS = [
	{
		title: 'Request rides',
		description: 'Effortlessly arrange rides for anyone - get real-time trip updates via Xpress app, text, or automated calls.',
		iconName: 'hire',
	},
	{
		title: 'Package delivery',
		description: 'Need a rush on anything from retail finds to auto parts? We offer same-day delivery for local packages within weight limits.',
		iconName: 'delivery',
		isComing: true,
	},
	{
		title: 'Employee Transportation',
		description: 'Streamline your team\'s transportation: ditch the logistics hassle and save on shuttles with on-demand rides.',
		iconName: 'ride',
	},
	{
		title: 'Schedule Rides',
		description: 'From retail orders to automotive supplies, we can help you request same-day delivery of packages within local weight restrictions.',
		iconName: 'schedule',
		isComing: true,
	}
]

const ConciergeServiceCards = () => {
	return (
		<Container className="grid grid-cols-2 tablet:!grid-cols-1 gap-4 tablet:gap-3 auto-rows-fr">
			{(CARDS.map((card, index) => (
				<CardContainer key={card.title + index}>
					<Row className="gap-4 tablet:gap-3 p-[24px] tablet:p-4">
						<img
							className="flex-shrink-0 tablet:w-20 tablet:h-20"
							alt={`${card.iconName} icon`}
							src={`/images/service-icons/${card.iconName}.svg`}
							width={120}
							height={120}
						/>
						<Column className="gap-4 min-w-0">
							<Row className="gap-[10px] justify-between items-start min-w-0">
								<h3 className="font-poppins text-xl leading-[24px] font-medium text-primary min-w-0 break-words">{card.title}</h3>
								{card.isComing
									? <ComingSoonBadge />
									: null}
							</Row>
							<span className="font-poppins text-sm leading-[20px]">{card.description}</span>
						</Column>
					</Row>
				</CardContainer>
			)))}
		</Container>
	);
};

export default ConciergeServiceCards;
